'use client'

import { useEffect } from 'react'
import { useParams } from 'next/navigation'
import * as Sentry from '@sentry/nextjs'

import VesselError from '@/app/components/VesselError/VesselError'

type ErrorProps = {
  error: Error & { digest?: string }
}

export default function Error({ error }: ErrorProps) {
  const params = useParams()
  const imo = params?.imo as string

  useEffect(() => {
    // Log the error to Sentry for monitoring
    Sentry.captureException(error, {
      tags: {
        section: 'vessel-page',
        imo: imo
      },
      extra: {
        locale: params?.locale,
        errorMessage: error.message,
        digest: error.digest
      }
    })

    // Log to console in development
    if (process.env.NODE_ENV !== 'production') {
      console.error('[VesselPage] Failed to fetch vessel data:', {
        imo,
        error: error.message,
        digest: error.digest
      })
    }
  }, [error, imo, params?.locale])

  return (
    <div className="page vessel-page">
      <VesselError imo={imo} errorMessage={error.message} />
    </div>
  )
}
